var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g({staticClass:"mini-button text-nowrap p-1",attrs:{"size":"sm","variant":_vm.variant,"to":_vm.to}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }